import React from 'react';

const Fail = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.08" cx="8" cy="8" r="8" fill="#FF8286" />
    <path
      d="M4.86963 4.86957L11.1305 11.1304"
      stroke="#FF8286"
      strokeWidth="2"
    />
    <path
      d="M4.86963 11.1304L11.1305 4.86957"
      stroke="#FF8286"
      strokeWidth="2"
    />
  </svg>
);

export default Fail;
